"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const lazy_1 = __importDefault(require("react-player/lazy"));
const hooks_1 = require("../../hooks");
const styles_1 = require("../../styles");
const styles_2 = require("../../styles");
const hooks_2 = require("../../hooks");
exports.Video = (0, react_1.memo)(({ data }) => {
    const { platform, long_video: longVideo, short_video: shortVideo } = data;
    const [playing, setPlaying] = (0, react_1.useState)(true);
    const { ref, inView } = (0, hooks_1.useInView)({
        rootMargin: '0px',
        threshold: 0,
        triggerOnce: true
    });
    const { isMobile } = (0, hooks_2.useDeviceType)();
    const url = `https://www.${platform}.com/${platform === 'youtube' ? 'watch?v=' : ''}${longVideo !== null && longVideo !== void 0 ? longVideo : shortVideo}`;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Figure, Object.assign({ ref: ref, className: 'figure--video' }, { children: (0, jsx_runtime_1.jsx)(lazy_1.default, { url: url, playsinline: true, controls: false, volume: 0, muted: true, loop: true, title: '', playing: isMobile ? true : playing }) })) }));
});
const Figure = styled_components_1.default.figure `
  height: auto;
  position: relative;
  width: 100%;

  img {
    width: 100%;
  }

  figcaption {
    ${(0, styles_2.getP12)()}
    border-bottom: ${({ theme }) => (0, styles_2.hex2Rgba)(theme.colors.black, .1)};
    padding-bottom: ${(0, styles_1.vw)(20, 'mobile')};
    margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};

    ${styles_1.mq.greaterThan('tablet')} {
      padding-bottom: ${(0, styles_1.vw)(20, 'desktop')};
      margin-bottom: ${(0, styles_1.vw)(20, 'desktop')};
    }
  }

  > div {
    height: 100%!important;
    width: 100%!important;
  }

  iframe {
    aspect-ratio: 16 / 9;
    height: 100% !important;
    width: auto !important;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);

    ${styles_1.mq.greaterThan('tablet')} {
      left: unset;
      position: unset;
      transform: none;
      height: auto !important;
      width: 100% !important;
    }
    ${styles_1.mq.greaterThan('desktop')} {
      position: absolute;
      top: 50%;
      transform: translateY(-55%);
    }

  }
`;
